import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {UserTagModel} from "../../models/user-tag.model";
import {FolderModel} from "../../models/folder.model";
import {EditTagModel} from "../../models/edit-tag.model";

@Component({
  selector: 'edit-tag-modal',
  templateUrl: './edit-tag-modal.component.html',
  styleUrls: ['./edit-tag-modal.component.css']
})
export class EditTagModalComponent implements OnInit {

  @Output() editTagEvent = new EventEmitter<EditTagModel>();
  @Output() closeEvent = new EventEmitter();
  @Output() tagChangedEvent = new EventEmitter();
  @Input() editTagErrorMessage: String;
  @Input() currentTag: UserTagModel;
  @Input() folders: FolderModel[];
  editTagForm: FormGroup;

  constructor() { }

  ngOnInit() {
    this.editTagForm = new FormGroup({
      tag: new FormControl(this.currentTag.tag),
      folderId: new FormControl(this.getTagFolderId(this.currentTag))
    });
    this.editTagForm.valueChanges.subscribe(value => {
      this.tagChangedEvent.emit();
    });
  }

  editTag() {
    this.editTagEvent.emit(this.editTagForm.value);
  }

  cancel($event) {
    if ($event.currentTarget === $event.target) {
      this.closeEvent.emit();
    }
  }

  getTagFolderId(tag: UserTagModel): number {
    if (!tag.folderId) {
      return tag.tagType === 'ARTIST' ? -1 : -2;
    }
    return tag.folderId;
  }

  getTag(): FormControl {
    return this.editTagForm.get('tag') as FormControl;
  }

  getFolderId(): FormControl {
    return this.editTagForm.get('folderId') as FormControl;
  }

  editEnabled(): boolean {
    if (!this.getTag().value) {
      return false;
    }
    if (this.getTag().value !== this.currentTag.tag) {
      return true;
    }
    if (this.currentTag.folderId === this.getFolderId().value) {
      return false;
    }
    if (this.currentTag.folderId === null && this.getFolderId().value < 0) {
      return false;
    }
    return true;
  }
}
